import { useDispatch } from 'react-redux';
import { usePlatformDashboardSelector } from 'platform-dashboard-ui/store';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error migrate upstream dependency
import { trackFilterInteraction } from 'dashboard-ui-components/tracking/DashboardUITracker';
import { selectDataSourcesMetadataWithUniqueLabels } from 'platform-dashboard-ui/ducks/dataSourceMetadataSlice';
// @ts-expect-error migrate upstream dependency
import { getName } from '../../../../lib/dashboardFilters/propertySchema';
// @ts-expect-error migrate upstream dependency
import { getFullyQualifiedName } from '../../../../lib/dashboardFilters/dataSourceMetadataSchema';
// @ts-expect-error migrate upstream dependency
import { unpinUngroupedQuickFilter } from '../../../../ducks/quick-filters/quickFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PinnedPropertyFilterInputFooter = ({
  dataSource,
  property,
  onApplyFilter,
  userHasQuickFilterEditPermission,
  dashboardId,
  isValid
}) => {
  const dispatch = useDispatch();
  const dataSourceMetadata = usePlatformDashboardSelector(selectDataSourcesMetadataWithUniqueLabels([dataSource]));
  const propertyName = getName(property);
  const handleUnpinFilter = () => {
    dispatch(unpinUngroupedQuickFilter({
      dataSourceId: dataSource,
      name: propertyName
    }));
    trackFilterInteraction({
      action: 'unpin-filter',
      filterData: {
        dataSource,
        dataSourceName: getFullyQualifiedName(dataSourceMetadata[dataSource]),
        property
      },
      additionalProps: {
        interactionSource: 'filters-panel',
        dashboardId
      }
    });
  };
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    justify: "between",
    paddingBlock: "400",
    children: [/*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "apply-filter-button",
      use: "tertiary",
      size: 'small',
      onClick: onApplyFilter,
      disabled: !isValid,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.apply"
      })
    }), /*#__PURE__*/_jsx(UITooltip, {
      disabled: userHasQuickFilterEditPermission,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.permissionConfig"
      }),
      children: /*#__PURE__*/_jsxs(UIButton, {
        use: "transparent",
        size: "small",
        disabled: !userHasQuickFilterEditPermission,
        "data-test-id": "popover-unpin-quick-filter-button",
        onClick: e => {
          e.stopPropagation();
          handleUnpinFilter();
        },
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "delete"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "quickFilter.unpin.title"
        })]
      })
    })]
  });
};
export default PinnedPropertyFilterInputFooter;